var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFirefox = function SvgFirefox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9875 3.9246C16.1798 1.54465 13.3622 0.059407 10.399 0.00214485C8.07704 -0.0436649 6.47077 0.653502 5.56586 1.21467C6.78003 0.510347 8.537 0.110943 10.0754 0.130984C14.0329 0.181089 18.2825 2.87527 18.9138 7.73182C19.638 13.307 15.7549 17.9596 10.2911 17.9739C4.28027 17.9889 0.624918 12.6678 1.57768 7.88858C1.62553 7.65022 1.60125 7.4176 1.68124 7.19213C1.72624 6.35181 2.04406 5.03477 2.729 3.68911C2.03692 4.047 1.15772 5.17936 0.720623 6.22869C0.0928279 7.74113 -0.127865 9.5499 0.0706868 11.2706C0.0856853 11.4002 0.0992554 11.5297 0.116397 11.6579C0.37213 13.1552 0.963726 14.5748 1.84658 15.8097C2.72944 17.0445 3.88051 18.0624 5.21301 18.7865C6.54551 19.5106 8.02467 19.9221 9.53895 19.99C11.0532 20.0578 12.5631 19.7803 13.9548 19.1782C15.3465 18.5761 16.5836 17.6652 17.5728 16.5143C18.5621 15.3633 19.2778 14.0022 19.6658 12.5337C20.0538 11.0653 20.1041 9.52764 19.8129 8.03683C19.5217 6.54601 18.8966 5.14091 17.9846 3.92747L17.9875 3.9246Z",
    fill: "url(#paint0_radial_3277_5009)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.67
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9875 3.9246C16.1798 1.54465 13.3622 0.059407 10.399 0.00214485C8.07704 -0.0436649 6.47077 0.653502 5.56586 1.21467C6.78003 0.510347 8.537 0.110943 10.0754 0.130984C14.0329 0.181089 18.2825 2.87527 18.9138 7.73182C19.638 13.307 15.7549 17.9596 10.2911 17.9739C4.28027 17.9889 0.624918 12.6678 1.57768 7.88858C1.62553 7.65022 1.60125 7.4176 1.68124 7.19213C1.72624 6.35181 2.04406 5.03477 2.729 3.68911C2.03692 4.047 1.15772 5.17936 0.720623 6.22869C0.0928279 7.74113 -0.127865 9.5499 0.0706868 11.2706C0.0856853 11.4002 0.0992554 11.5297 0.116397 11.6579C0.37213 13.1552 0.963726 14.5748 1.84658 15.8097C2.72944 17.0445 3.88051 18.0624 5.21301 18.7865C6.54551 19.5106 8.02467 19.9221 9.53895 19.99C11.0532 20.0578 12.5631 19.7803 13.9548 19.1782C15.3465 18.5761 16.5836 17.6652 17.5728 16.5143C18.5621 15.3633 19.2778 14.0022 19.6658 12.5337C20.0538 11.0653 20.1041 9.52764 19.8129 8.03683C19.5217 6.54601 18.8966 5.14091 17.9846 3.92747L17.9875 3.9246Z",
    fill: "url(#paint1_radial_3277_5009)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9875 3.9246C16.1798 1.54465 13.3622 0.059407 10.399 0.00214485C8.07704 -0.0436649 6.47077 0.653502 5.56586 1.21467C6.78003 0.510347 8.537 0.110943 10.0754 0.130984C14.0329 0.181089 18.2825 2.87527 18.9138 7.73182C19.638 13.307 15.7549 17.9596 10.2911 17.9739C4.28027 17.9889 0.624918 12.6678 1.57768 7.88858C1.62553 7.65022 1.60125 7.4176 1.68124 7.19213C1.72624 6.35181 2.04406 5.03477 2.729 3.68911C2.03692 4.047 1.15772 5.17936 0.720623 6.22869C0.0928279 7.74113 -0.127865 9.5499 0.0706868 11.2706C0.0856853 11.4002 0.0992554 11.5297 0.116397 11.6579C0.37213 13.1552 0.963726 14.5748 1.84658 15.8097C2.72944 17.0445 3.88051 18.0624 5.21301 18.7865C6.54551 19.5106 8.02467 19.9221 9.53895 19.99C11.0532 20.0578 12.5631 19.7803 13.9548 19.1782C15.3465 18.5761 16.5836 17.6652 17.5728 16.5143C18.5621 15.3633 19.2778 14.0022 19.6658 12.5337C20.0538 11.0653 20.1041 9.52764 19.8129 8.03683C19.5217 6.54601 18.8966 5.14091 17.9846 3.92747L17.9875 3.9246Z",
    fill: "url(#paint2_radial_3277_5009)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9875 3.9246C16.1798 1.54465 13.3622 0.059407 10.399 0.00214485C8.07704 -0.0436649 6.47077 0.653502 5.56586 1.21467C6.78003 0.510347 8.537 0.110943 10.0754 0.130984C14.0329 0.181089 18.2825 2.87527 18.9138 7.73182C19.638 13.307 15.7549 17.9596 10.2911 17.9739C4.28027 17.9889 0.624918 12.6678 1.57768 7.88858C1.62553 7.65022 1.60125 7.4176 1.68124 7.19213C1.72624 6.35181 2.04406 5.03477 2.729 3.68911C2.03692 4.047 1.15772 5.17936 0.720623 6.22869C0.0928279 7.74113 -0.127865 9.5499 0.0706868 11.2706C0.0856853 11.4002 0.0992554 11.5297 0.116397 11.6579C0.37213 13.1552 0.963726 14.5748 1.84658 15.8097C2.72944 17.0445 3.88051 18.0624 5.21301 18.7865C6.54551 19.5106 8.02467 19.9221 9.53895 19.99C11.0532 20.0578 12.5631 19.7803 13.9548 19.1782C15.3465 18.5761 16.5836 17.6652 17.5728 16.5143C18.5621 15.3633 19.2778 14.0022 19.6658 12.5337C20.0538 11.0653 20.1041 9.52764 19.8129 8.03683C19.5217 6.54601 18.8966 5.14091 17.9846 3.92747L17.9875 3.9246Z",
    fill: "url(#paint3_radial_3277_5009)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9875 3.9246C16.1798 1.54465 13.3622 0.059407 10.399 0.00214485C8.07704 -0.0436649 6.47077 0.653502 5.56586 1.21467C6.78003 0.510347 8.537 0.110943 10.0754 0.130984C14.0329 0.181089 18.2825 2.87527 18.9138 7.73182C19.638 13.307 15.7549 17.9596 10.2911 17.9739C4.28027 17.9889 0.624918 12.6678 1.57768 7.88858C1.62553 7.65022 1.60125 7.4176 1.68124 7.19213C1.72624 6.35181 2.04406 5.03477 2.729 3.68911C2.03692 4.047 1.15772 5.17936 0.720623 6.22869C0.0928279 7.74113 -0.127865 9.5499 0.0706868 11.2706C0.0856853 11.4002 0.0992554 11.5297 0.116397 11.6579C0.37213 13.1552 0.963726 14.5748 1.84658 15.8097C2.72944 17.0445 3.88051 18.0624 5.21301 18.7865C6.54551 19.5106 8.02467 19.9221 9.53895 19.99C11.0532 20.0578 12.5631 19.7803 13.9548 19.1782C15.3465 18.5761 16.5836 17.6652 17.5728 16.5143C18.5621 15.3633 19.2778 14.0022 19.6658 12.5337C20.0538 11.0653 20.1041 9.52764 19.8129 8.03683C19.5217 6.54601 18.8966 5.14091 17.9846 3.92747L17.9875 3.9246Z",
    fill: "url(#paint4_radial_3277_5009)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9142 7.73182C18.9928 8.33203 19.0179 8.93807 18.9892 9.54274C19.3213 9.49407 19.6534 9.44897 19.9891 9.41032C19.8829 7.42287 19.1865 5.51257 17.9893 3.9246C16.1816 1.54465 13.364 0.059407 10.4007 0.00214485C8.07881 -0.0436649 6.47254 0.653502 5.56763 1.21467C6.78179 0.510347 8.53876 0.110943 10.0772 0.130984C14.0332 0.181089 18.2828 2.87527 18.9142 7.73182Z",
    fill: "url(#paint5_linear_3277_5009)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.157 7.45485C18.5942 2.37927 14.0668 0.0959399 10.0729 0.131013C8.53449 0.143181 6.77752 0.510375 5.56336 1.2147C5.24236 1.40548 4.94384 1.6319 4.67344 1.88968C4.70558 1.86319 4.802 1.78374 4.95913 1.67494L4.97484 1.66349L4.98913 1.65419C5.57973 1.25539 6.2303 0.954045 6.91608 0.761613C7.97098 0.452397 9.11301 0.348609 10.2115 0.376525C14.726 0.636352 17.9121 4.38488 18.0228 8.37104C18.115 11.6715 15.4131 14.3041 12.2984 14.4551C10.0329 14.5654 7.89884 13.4695 6.85609 11.2771C6.61252 10.7779 6.44702 10.2441 6.36542 9.69452C5.87118 6.35828 8.11239 3.51235 10.1679 2.80802C9.05873 1.83957 6.28114 1.90543 4.21349 3.42645C2.72435 4.52159 1.75873 6.18792 1.43876 8.17564C1.1945 9.69165 1.42448 11.2678 2.0237 12.675C2.66171 14.1769 3.70211 15.4725 5.02965 16.4182C6.35719 17.364 7.92005 17.923 9.54511 18.0333C9.79294 18.0519 10.0451 18.0612 10.2907 18.0612C16.9058 18.062 19.7762 13.0422 19.157 7.45485Z",
    fill: "url(#paint6_radial_3277_5009)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.157 7.45485C18.5942 2.37927 14.0668 0.0959399 10.0729 0.131013C8.53449 0.143181 6.77752 0.510375 5.56336 1.2147C5.24236 1.40548 4.94384 1.6319 4.67344 1.88968C4.70558 1.86319 4.802 1.78374 4.95913 1.67494L4.97484 1.66349L4.98913 1.65419C5.57973 1.25539 6.2303 0.954045 6.91608 0.761613C7.97098 0.452397 9.11301 0.348609 10.2115 0.376525C14.726 0.636352 17.9121 4.38488 18.0228 8.37104C18.115 11.6715 15.4131 14.3041 12.2984 14.4551C10.0329 14.5654 7.89884 13.4695 6.85609 11.2771C6.61252 10.7779 6.44702 10.2441 6.36542 9.69452C5.87118 6.35828 8.11239 3.51235 10.1679 2.80802C9.05873 1.83957 6.28114 1.90543 4.21349 3.42645C2.72435 4.52159 1.75873 6.18792 1.43876 8.17564C1.1945 9.69165 1.42448 11.2678 2.0237 12.675C2.66171 14.1769 3.70211 15.4725 5.02965 16.4182C6.35719 17.364 7.92005 17.923 9.54511 18.0333C9.79294 18.0519 10.0451 18.0612 10.2907 18.0612C16.9058 18.062 19.7762 13.0422 19.157 7.45485Z",
    fill: "url(#paint7_radial_3277_5009)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.53,
    d: "M19.157 7.45485C18.5942 2.37927 14.0668 0.0959399 10.0729 0.131013C8.53449 0.143181 6.77752 0.510375 5.56336 1.2147C5.24236 1.40548 4.94384 1.6319 4.67344 1.88968C4.70558 1.86319 4.802 1.78374 4.95913 1.67494L4.97484 1.66349L4.98913 1.65419C5.57973 1.25539 6.2303 0.954045 6.91608 0.761613C7.97098 0.452397 9.11301 0.348609 10.2115 0.376525C14.726 0.636352 17.9121 4.38488 18.0228 8.37104C18.115 11.6715 15.4131 14.3041 12.2984 14.4551C10.0329 14.5654 7.89884 13.4695 6.85609 11.2771C6.61252 10.7779 6.44702 10.2441 6.36542 9.69452C5.87118 6.35828 8.11239 3.51235 10.1679 2.80802C9.05873 1.83957 6.28114 1.90543 4.21349 3.42645C2.72435 4.52159 1.75873 6.18792 1.43876 8.17564C1.1945 9.69165 1.42448 11.2678 2.0237 12.675C2.66171 14.1769 3.70211 15.4725 5.02965 16.4182C6.35719 17.364 7.92005 17.923 9.54511 18.0333C9.79294 18.0519 10.0451 18.0612 10.2907 18.0612C16.9058 18.062 19.7762 13.0422 19.157 7.45485Z",
    fill: "url(#paint8_radial_3277_5009)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.53,
    d: "M19.157 7.45485C18.5942 2.37927 14.0668 0.0959399 10.0729 0.131013C8.53449 0.143181 6.77752 0.510375 5.56336 1.2147C5.24236 1.40548 4.94384 1.6319 4.67344 1.88968C4.70558 1.86319 4.802 1.78374 4.95913 1.67494L4.97484 1.66349L4.98913 1.65419C5.57973 1.25539 6.2303 0.954045 6.91608 0.761613C7.97098 0.452397 9.11301 0.348609 10.2115 0.376525C14.726 0.636352 17.9121 4.38488 18.0228 8.37104C18.115 11.6715 15.4131 14.3041 12.2984 14.4551C10.0329 14.5654 7.89884 13.4695 6.85609 11.2771C6.61252 10.7779 6.44702 10.2441 6.36542 9.69452C5.87118 6.35828 8.11239 3.51235 10.1679 2.80802C9.05873 1.83957 6.28114 1.90543 4.21349 3.42645C2.72435 4.52159 1.75873 6.18792 1.43876 8.17564C1.1945 9.69165 1.42448 11.2678 2.0237 12.675C2.66171 14.1769 3.70211 15.4725 5.02965 16.4182C6.35719 17.364 7.92005 17.923 9.54511 18.0333C9.79294 18.0519 10.0451 18.0612 10.2907 18.0612C16.9058 18.062 19.7762 13.0422 19.157 7.45485Z",
    fill: "url(#paint9_radial_3277_5009)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2985 14.4565C16.5738 14.196 18.4029 10.6579 18.5172 8.14693C18.6965 4.22447 16.3689 -0.00505799 10.2116 0.376451C9.11314 0.348536 7.97111 0.452324 6.91621 0.76154C6.23501 0.962673 5.58714 1.26344 4.99355 1.65411L4.97926 1.66342L4.96355 1.67487C4.86832 1.74168 4.77476 1.81182 4.68286 1.88531C4.85427 1.76792 6.97764 0.513881 9.92735 0.901116C13.462 1.36494 16.6938 4.11496 16.6938 7.74252C16.6938 10.534 14.5362 12.6649 12.01 12.5132C8.2568 12.287 7.31117 8.43897 9.26313 6.77622C8.73675 6.66241 7.74685 6.88501 7.05834 7.9143C6.43983 8.83837 6.47483 10.2663 6.85622 11.2785C7.89897 13.4709 10.0345 14.5939 12.2985 14.4565Z",
    fill: "url(#paint10_radial_3277_5009)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9868 3.9247C17.7192 3.57389 17.4286 3.24128 17.1169 2.92906C16.869 2.66755 16.6036 2.42315 16.3227 2.19753C16.4842 2.33873 16.6384 2.48804 16.7848 2.64489C17.3317 3.22861 17.7478 3.92265 18.0054 4.68057C18.5275 6.26243 18.4932 8.24227 17.4962 9.79694C16.3084 11.6494 14.3736 12.5641 12.2824 12.5169C12.1917 12.5169 12.101 12.5169 12.0096 12.5105C8.25636 12.2843 7.31074 8.43625 9.26269 6.7735C8.73632 6.65969 7.74642 6.8823 7.05791 7.91158C6.4394 8.83565 6.4744 10.2636 6.85579 11.2757C6.61222 10.7765 6.44673 10.2428 6.36512 9.69315C5.87089 6.35692 8.11209 3.51098 10.1676 2.80666C9.05843 1.83821 6.28085 1.90406 4.21319 3.42509C3.00831 4.31122 2.14625 5.57242 1.6913 7.07556C1.75843 6.23237 2.07697 4.97403 2.73119 3.6885C2.03912 4.04639 1.15992 5.17875 0.72282 6.22808C0.0950247 7.74051 -0.125668 9.54928 0.0728842 11.27C0.0878827 11.3996 0.101453 11.5291 0.118594 11.6572C0.374541 13.1543 0.966255 14.5736 1.84913 15.8081C2.73201 17.0427 3.88301 18.0603 5.21537 18.7841C6.54773 19.508 8.02668 19.9194 9.54072 19.9871C11.0548 20.0549 12.5644 19.7773 13.9559 19.1753C15.3473 18.5733 16.5842 17.6626 17.5734 16.5118C18.5625 15.361 19.2781 14.0002 19.6662 12.532C20.0542 11.0638 20.1046 9.5264 19.8136 8.03579C19.5226 6.54518 18.8977 5.14023 17.9861 3.92685L17.9868 3.9247Z",
    fill: "url(#paint11_linear_3277_5009)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0045 4.68054C17.7481 3.92272 17.3329 3.22864 16.7868 2.64487C16.149 1.95486 15.354 1.42805 14.5134 1.0222C13.8019 0.671762 13.0518 0.406067 12.2786 0.230554C10.9147 -0.0680956 9.50346 -0.0763863 8.13617 0.206218C6.7156 0.505413 5.46644 1.12027 4.67651 1.88901C5.2686 1.53112 6.09494 1.23694 6.68346 1.08806C9.41605 0.398046 12.425 1.14532 14.4763 3.11227C14.8915 3.50646 15.2551 3.9519 15.5583 4.43789C16.7818 6.42704 16.666 8.92796 15.7119 10.4025C15.0034 11.4983 13.4856 12.5262 12.0694 12.5147C14.242 12.6285 16.2682 11.7131 17.4974 9.79477C18.493 8.24225 18.5273 6.26241 18.0045 4.68054Z",
    fill: "url(#paint12_linear_3277_5009)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0045 4.68054C17.7481 3.92272 17.3329 3.22864 16.7868 2.64487C16.149 1.95486 15.354 1.42805 14.5134 1.0222C13.8019 0.671762 13.0518 0.406067 12.2786 0.230554C10.9147 -0.0680956 9.50346 -0.0763863 8.13617 0.206218C6.7156 0.505413 5.46644 1.12027 4.67651 1.88901C5.2686 1.53112 6.09494 1.23694 6.68346 1.08806C9.41605 0.398046 12.425 1.14532 14.4763 3.11227C14.8915 3.50646 15.2551 3.9519 15.5583 4.43789C16.7818 6.42704 16.666 8.92796 15.7119 10.4025C15.0034 11.4983 13.4856 12.5262 12.0694 12.5147C14.242 12.6285 16.2682 11.7131 17.4974 9.79477C18.493 8.24225 18.5273 6.26241 18.0045 4.68054Z",
    fill: "url(#paint13_linear_3277_5009)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3277_5009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.8839 3.78789) scale(22.6928 22.7424)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FF5D36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F1136E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#DA057A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#D2007F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_3277_5009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1.65982 4.72842) scale(13.4301 13.4595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5007F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5156C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_3277_5009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.8237 2.49376) scale(26.6474 26.7056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD00",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFD702",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#FEC606",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FDA90E",
    stopOpacity: 0.43
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FC8119",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FA4E27",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F92433",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_3277_5009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.5732 11.1246) scale(34.3773 34.4525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#DB293D",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F5334B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_3277_5009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(7.97134 10.6916) scale(34.3773 34.4525)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#DB293D",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#F5334B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3277_5009",
    x1: 11.4599,
    y1: 1.94333,
    x2: 17.3608,
    y2: 12.1427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBC04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#FFAB02",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF9B01",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FF9200",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FF8E00",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_3277_5009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3218 3.02221) scale(21.325 21.3716)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#FF7139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF5B51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF4F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#FF4055"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#FF3750"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_3277_5009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.3218 3.02221) scale(21.325 21.3716)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#FFDE08"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFDB08",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFD209",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFC40B",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FFB00D",
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#FF970F",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FF7B12",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_3277_5009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.5642 9.71652) rotate(75.5778) scale(10.4853 10.896)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FF4D47",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF673D",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF7139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_3277_5009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.6857 10.4912) scale(10.4461 10.469)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FF3750",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF444B",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FF643E",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF7139",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_3277_5009",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.5784 0.607504) scale(36.0431 36.1219)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FF8424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FF7634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3277_5009",
    x1: 14.7564,
    y1: 1.76449,
    x2: 4.51682,
    y2: 19.4606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF44F",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3277_5009",
    x1: 11.5073,
    y1: 12.5756,
    x2: 11.5073,
    y2: 0.127482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3277_5009",
    x1: 6.93629,
    y1: 0.0702206,
    x2: 17.0366,
    y2: 10.1492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E008B",
    stopOpacity: 0.5
  })))));
};

export { SvgFirefox as ReactComponent };
export default __webpack_public_path__ + "static/firefox.7a611c58.svg";